import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import "./qrScan.css";

export default function QRScanner() {
  const scannerRef = useRef(null);
  const isScanningRef = useRef(false);

  useEffect(() => {
    // ❌ prevent multiple instances (VERY IMPORTANT)
    if (scannerRef.current) return;

    const html5QrCode = new Html5Qrcode("reader");
    scannerRef.current = html5QrCode;

    const startScanner = async () => {
      if (isScanningRef.current) return;

      try {
        // 🔥 clear previous camera (fix double video)
        const reader = document.getElementById("reader");
        if (reader) reader.innerHTML = "";

        await html5QrCode.start(
          { facingMode: "environment" },
          {
            fps: 10,
            qrbox: { width: 250, height: 250 },
          },
          (decodedText) => {
            if (!isScanningRef.current) return;

            isScanningRef.current = false;

            if (html5QrCode.isScanning) {
              html5QrCode
                .stop()
                .then(() => {
                  try {
                    const url = new URL(decodedText);

                    // ✅ better UX (same tab)
                    window.location.href = url.href;

                  } catch {
                    alert("Scanned text: " + decodedText);
                  }
                })
                .catch(() => {});
            }
          },
          () => {}
        );

        isScanningRef.current = true;
      } catch (err) {
        console.error("Camera start error:", err);
      }
    };

    startScanner();

    return () => {
      if (scannerRef.current?.isScanning) {
        scannerRef.current
          .stop()
          .then(() => scannerRef.current.clear())
          .catch(() => {});
      }
    };
  }, []);

  return (
    <div className="qr-container">
      <div className="qr-header">
        <span
          className="close"
          onClick={() => window.close()}
        >
          ✕
        </span>
        <h2>Scan QR Code</h2>
      </div>

      <div className="tag">
        <div className="dot"></div>
        <span>MAKING PRINT EASY</span>
      </div>

      <div className="scanner-wrapper">
        <div id="reader" className="qr-reader"></div>

        <div className="overlay">
          <div className="corner tl"></div>
          <div className="corner tr"></div>
          <div className="corner bl"></div>
          <div className="corner br"></div>
          <div className="scan-line"></div>
        </div>
      </div>

      <p className="qr-text">
        Align QR code within the frame to scan
      </p>

      <button className="scan-btn">
        PRINT FAST AND SECURE
      </button>
    </div>
  );
}